import {Directive, HostBinding, HostListener, Input, Attribute } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, RouterLinkWithHref, ActivatedRoute, NavigationEnd } from '@angular/router'

import { NotificationService } from "../../utils/notification.service";

import { NavigationCountService } from './navigation-count-service' ;
import { Subscription } from 'rxjs/Subscription';

import { SessionSetting, Resources } from '../../../app.service';
import { KeycloakService } from '../../../keycloak.service';
import { LayoutService } from "../layout.service";

// 注意：
//    app.routing.ts の　RouterModule.forRoot(routes, {useHash: true});
//    useHash: trueが必要
// Config from :   assets/config.js
//  var config = {
//    ....
//    // SPA 画面遷移回数制限 (Home メニュー)
//    // 未設定、又は 0の場合、画面refresh を行わない
//    homeNavigationLimit: 10,
//
// 

declare var $: any;
declare var config: any;

@Directive({
  selector: 'a[extendedRouterLink]'
})
export class ExtendedRouterLinkWithHrefDirective extends RouterLinkWithHref {

  //
  private navigationEndSubscription : Subscription ;

  constructor( private _router: Router, private _route: ActivatedRoute, locationStrategy: LocationStrategy, private countService: NavigationCountService,
      private notificationService: NotificationService, private kc: KeycloakService, private layoutService: LayoutService) {
    super(_router, _route, locationStrategy) ;
  }

  @Input('extendedRouterLink') 
  set extendedRouterLink(v: any[] | string ) {
    // 親クラスのメンバーを呼び出す
    this.routerLink = v ;
  }

  // Override base class method
  onClick(button: number, ctrlKey: boolean, metaKey: boolean, shiftKey: boolean): boolean {
    if ($('body').is('.hidden-menu') && $('body').is('.mobile-view-activated')) {
      this.layoutService.onCollapseMenu();
    }
    if (this.href == '#/menu.layoutOptions') {
      //$('#layoutOptionsDlg').show();
      $('#layoutOptionsDlg').modal('show');
      return false;
    } else if (this.href == '#/menu.cacheRefresh') {
      this.layoutService.factoryReset();
      return false;
    } else if (this.href == '#/menu.logout') {
      this.showLogoutPopup();
      return false;
    } else if(config.homeNavigationLimit && this.countService.increament()>=config.homeNavigationLimit) {
      if (button !== 0 || ctrlKey || metaKey) {
        return true;
      }
      if (typeof this.target === 'string' && this.target != '_self') {
        return true;
      }

      // ありえない、安全のために：
      if(this.navigationEndSubscription) {
        this.navigationEndSubscription.unsubscribe() ;
        this.navigationEndSubscription = null ;
      }
      // Event 処理を追加する
      this.navigationEndSubscription = this._router.events
          .filter(e=>e instanceof NavigationEnd)
          .subscribe((e:NavigationEnd)=>{
            // 画面再ロード
            window.location.reload(true) ;
          }) ;
      this._router.navigateByUrl(this.urlTree, {replaceUrl: true});
      return false;
    } else {
      return super.onClick(button, ctrlKey, metaKey, shiftKey) ;
    }
  }

  showLogoutPopup() {
    this.notificationService.smartMessageBox({
      title : "<i class='fa fa-sign-out txt-color-orangeDark'></i> " + config.title + "<span class='txt-color-orangeDark'><strong>" + $('#show-shortcut').text() + "</strong></span>",
      content : Resources.getMessage('main.logout.ask'),
      buttons : '[' + Resources.getLabel('Cancel') + '][OK]'

    }, (ButtonPressed) => {
      if (ButtonPressed == "OK") {
        this.logout()
      }
    });
  }

  logout() {
      //www this.router.navigate(['/auth/login'])
      SessionSetting.set('Token', null) ;   // セッションTOKENを削除する
      SessionSetting.setUser(null);
      if (config.devMode) {
        //this._router.navigate(['login']);
        location.href = "/";
      } else {
        this.kc.logout();
      }
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/navigation/extended-routerlinkwithhref-directive.ts